module.exports = __webpack_public_path__ + "static/media/variance-icon.a7bd261d.png";